/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { cssProps } from '@oracle/oraclejet-cssprops';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { preventDefaultForCurrentTarget } from './eventUtils';

const rootStyles = cssProps`${{
  paddingBottom: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-spacing-3x)',
  paddingLeft: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-spacing-3x)',
  paddingRight: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-spacing-3x)',
  paddingTop: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-spacing-3x)'
}}`;

export function EmptyResults() {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  // TODO: figure out whether we need a separate resource string for this message;
  // (JET-53984 - Preact Select* components: empty results message)

  // call preventDefault for mousedown on this div so that focus does not transfer from
  // the input
  return (
    <div class={rootStyles} onMouseDown={preventDefaultForCurrentTarget}>
      {translations.select_noMatchesFound()}
    </div>
  );
}
